import React from 'react';

const YTDTable = ({ data, selectedStrategy, onStrategyClick, onYTDClick }) => {
  return (
    <table className="min-w-full divide-y divide-gray-200">
      <thead className=" ">
        <tr>
          <th className="border border-gray-300 px-2 py-[1px] text-sm text-left font-medium text-gray-100 uppercase tracking-wider">Strategy</th>
          {data[0]?.ytds?.map((item) => (
            <th key={item.year} className="border border-gray-300 px-2 py-[1px] text-sm font-medium text-gray-200 uppercase tracking-wider">
              {item.year}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="">
        {data?.map((item, idx) => (
          <tr
            key={item.strategy}
            onClick={() => onStrategyClick(idx)}
            className={`cursor-pointer ${idx === selectedStrategy ? ' text-gray-100 bg-amber-700' : 'text-gray-100'}`}
          >
            <td className="border border-gray-300 px-2 py-[1px] ">{item.strategy}</td>
            {item.ytds?.map((item, vIdx) => (
              <td
                key={vIdx}
                className="border border-gray-300 px-2 py-[1px] text-right  cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent row click event
                  onYTDClick(item.year, item.ytd_data,idx);
                }}
              >
                {item.ytd_data}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default YTDTable;








// import React from 'react';

// const YTDTable = ({ data, selectedStrategy, onStrategyClick, onYTDClick }) => {
//   return (
//     <table className="min-w-full divide-y divide-gray-200">
//       <thead className="bg-zinc-700 ">
//         <tr>
//           <th className="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">Strategy</th>
//           {Object.keys(data[0].YTDs).map((year) => (
//             <th key={year} className="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">
//               {year}
//             </th>
//           ))}
//         </tr>
//       </thead>
//       <tbody className="bg-white divide-y divide-gray-200">
//         {data.map((item, idx) => (
//           <tr
//             key={item.strategy}
//             onClick={() => onStrategyClick(idx)}
//             className={`cursor-pointer ${idx === selectedStrategy ? 'bg-gray-300 text-black font-medium' : 'text-gray-500'}`}
//           >
//             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium ">{item.strategy}</td>
//             {Object.entries(item.YTDs).map(([year, value], vIdx) => (
//               <td
//                 key={vIdx}
//                 className="px-6 py-4 whitespace-nowrap text-sm  cursor-pointer"
//                 onClick={(e) => {
//                   e.stopPropagation(); // Prevent row click event
//                   onYTDClick(year, value,idx);
//                 }}
//               >
//                 {value}
//               </td>
//             ))}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// };

// export default YTDTable;
